export default __webpack_public_path__ + "static/media/truck_load_promised.1c92218f.png";